<template>
  <base-dialog-form
    ref="viewListinoTessereDialog"
    :title="$t('catalog_affiliation_cards')"
    color="secondary"
    :type="type"
    icon="mdi-credit-card-multiple-outline"
  >
    <template v-slot:actions v-if="type !== 'dialog'">
      <v-row>
        <v-col cols="12" class="text-center">
          <v-btn @click="acquistoTessere" color="primary">{{
            configure ? $t("confirm") : $t("buy_affiliation_cards")
          }}</v-btn>
        </v-col>
      </v-row>
    </template>
    <v-container>
      <v-row>
        <v-col cols="12" class="text-center">
          <v-select
            v-if="configure"
            v-model="asdAffiliazione"
            :items="affilationList"
            item-value="affiliazione"
            item-text="descr"
            :disabled="affiliated"
            :menu-props="{ maxHeight: '400' }"
            :label="$t('select_affiliation_type')"
            required
            color="primary"
            persistent-hint
          ></v-select>
          <div v-else>{{ asdAffiliazione }}</div>
        </v-col>
      </v-row>
      <v-row
        ><v-col cols="12">
          <v-simple-table>
            <thead>
              <tr>
                <th>{{ $t("image") }}</th>
                <th>{{ $t("name") }}</th>
                <th>
                  <div class="text-right">{{ $t("price") }}</div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="tessera in listaTessere" v-bind:key="tessera.tesId">
                <td>
                  <div class="text-left">
                    <img style="height: 50px" :src="tessera.imgTessera" />
                  </div>
                </td>
                <td>
                  <div class="text-left">
                    <h3 :style="'color: ' + tessera.hexColor + ';'">
                      {{ tessera.nome }}
                    </h3>
                  </div>
                </td>
                <td>
                  <div class="text-right">{{ tessera.prezzo }}</div>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-container>
  </base-dialog-form>
</template>

<script>
export default {
  name: "view-listino-tessere",
  components: {},
  props: {
    paramsType: {
      type: String,
      default: null,
    },
    paramsAsdCode: {
      type: String,
      default: null,
    },
    paramsConfigure: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      type: null,
      asdCode: null,
      configure: false,
      fullListaTessere: [],
      affilationList: [],
      affiliated: false,
      asdAffiliazione: null,
      priceAffiliation: 0,
      buyUrl: "",
      haveEnte: window.systemData.haveEnte,
      isEnte: window.systemData.isEnte,
    };
  },
  methods: {
    open(asdCode) {
      this.type = "dialog";
      this.asdCode = asdCode;
      this.configure = false;
      this.loadData();
      this.$refs.viewListinoTessereDialog.open();
    },
    acquistoTessere() {
      // Procedi solo se scelta almeno una tessera

      if (this.configure) {
        let conta = this.listaTessere.filter((tessera) => {
          return tessera.qta > 0;
        });
        if (conta.length > 0)
          this.$emit("configured", {
            affiliated: this.affiliated,
            asdAffiliazione: this.asdAffiliazione,
            priceAffiliation: this.priceAffiliation,
            tessereScelte: this.listaTessere,
          });
      } else {
        window.open(this.buyUrl);
      }
    },
    loadData() {
      let _ = this;
      _.fullListaTessere = [];
      _.affiliated = false;
      _.priceAffiliation = 0;
      _.buyUrl = "";
      let url = "/auth/ente/getListinoTessere";
      if (_.asdCode) url = url + "/" + _.asdCode;
      _.chiamataAxios("GET", url).then((response) => {
        _.fullListaTessere = response.data.tessere;
        _.priceAffiliation = response.data.priceAffiliation;
        _.affiliated = response.data.affiliated;
        _.affilationList = response.data.affilationList;
        if (response.data.affiliated) {
          _.asdAffiliazione = response.data.asdAffiliazione;
        } else {
          _.asdAffiliazione = "";
        }
        _.buyUrl = response.data.buyUrl;
      });
    },
  },
  computed: {
    listaTessere: function () {
      let _ = this;
      let curAffiliazione = _.affilationList.filter((item) => {
        return item.affiliazione === _.asdAffiliazione;
      });
      if (curAffiliazione.length !== 1) return [];

      return this.fullListaTessere.filter((tessera) => {
        return curAffiliazione[0].tessere.includes(tessera.tesId);
      });
    },
  },
  watch: {
    paramsAsdCode: function (newVal, oldVal) {
      // watch it
      if (newVal !== null) {
        this.asdCode = newVal;
        this.loadData();
      }
    },
    paramsType: function (newVal, oldVal) {
      // watch it
      if (newVal !== null) {
        this.type = newVal;
        this.loadData();
      }
    },
  },
  mounted() {
    if (this.paramsAsdCode || this.paramsType || this.paramsConfigure) {
      if (this.paramsType) this.type = this.paramsType;
      else this.type = "plain";
      if (this.paramsAsdCode) this.asdCode = this.paramsAsdCode;
      else this.asdCode = null;
      if (this.paramsConfigure) this.configure = this.paramsConfigure;
      else this.configure = false;

      this.masterId = this.paramsMasterId;
      this.loadData();
    }
  },
};
</script>